import {ACTION_TYPES, COMPONENT_STATES, FETCHING_STATES, HISTORY_ACTIONS} from "../../../core/consts";
import {StandingsRequestParams} from "../../../domain/standings/models/standings.request-params";
import {StandingsDomainService} from "../../../domain/standings/services/standings.domain-service";
import {DeltaHandler} from "../../../infrastructure/handlers/delta-handler";
import {STANDINGS_WIDGET} from "../standings-widget.consts";
import {StandingsDataSource} from "../../../domain/standings/models/standings-data-source";
import {StandingsWidgetState} from "../models/standings-widget.state";
import {runInAction} from "mobx"

export class StandingsWidgetFetchHandler extends DeltaHandler {
  state: StandingsWidgetState;
  static injectables = [StandingsDomainService];

  async onLoaded() {
    await super.onLoaded();
    const isBack: Boolean = this.state.dataSource && this.historyManager.action === HISTORY_ACTIONS.pop;

    if (!isBack) {
      this.controller.action(STANDINGS_WIDGET.ACTION_TYPES.changeType, {disableFetch: true});
    } else {
      this.controller.action(STANDINGS_WIDGET.ACTION_TYPES.changeType, {disableFetch: true})
      this.action({isPartialFetch: isBack})
    }
    await this.action()

    await this.controller.action(STANDINGS_WIDGET.ACTION_TYPES.displayHandler, {isStandingsPage: this.state?.isStandingsPage})
  }

  get requestParams(): StandingsRequestParams {
    const selectedCompetitionId = this.state.selectedCompetitionId || this.controller.props.competitionIds;

    const competitionIds = [selectedCompetitionId];
    const competitorId = this.controller.props.competitorId;
    const filterType = !this.state.isGroupCategory ? this.state.activeFilter : null;
    const seasonNum = this.state.selectedSeasonNum || this.controller.props.seasonNum;
    const groupCategory = this.state.isGroupCategory && seasonNum === this.state.standings.seasonNum ? this.state.activeFilter : null;
    const isLive: Boolean = this.state.isLive;
    const isPreview = this.controller.props.isPreviewStandings;
    const stageNum = this.controller.props.relevantStageNum || this.state.stageNum;
    const context = this.controller.props.bookieContext;

    const withSeasonsFilter = this.controller.props.withSeasonsFilter;
    const requestParams: StandingsRequestParams = new StandingsRequestParams(competitionIds, competitorId, filterType, groupCategory, isLive, isPreview, stageNum, seasonNum, withSeasonsFilter, context);

    return requestParams;
  }

  async action(params) {
    let isPartialFetch: Boolean = params?.isPartialFetch;
    const currentParams = this.createDomainParams();
    const dataSource: StandingsDataSource = await this.fetch(currentParams, isPartialFetch);

    if (dataSource?.request.params.equals(currentParams.requestParams)) {
      await runInAction(async () => {
        this.state.currentCompetitionDataSource = dataSource;
      })

      await this.controller.action(ACTION_TYPES.populateData, {initDataSource: !isPartialFetch, dataSource});
      this.controller.props.onWidgetVisible?.(this.state.isPopulated);
      this.state.appState.settings.isWidget && await this.controller.action(ACTION_TYPES.poweredByChangeTitle, {
        name: this.state.competition.shortName || this.state.competition.name,
        linkModel: this.state.footerLinkModel
      });
    } else {
      this.store.setComponentState(COMPONENT_STATES.loaded);
      this.store.setFetchingState(FETCHING_STATES.idle);
    }

    return dataSource;
  }

  populateDelta(response, params) {
    runInAction(async () => {
      this.state.currentCompetitionDataSource = response;
    })
  }

  async onDidUpdate(prevProps, nextProps) {
    super.onDidUpdate(prevProps, nextProps);
    const defaultTabIndex = this.state.isGroupCategory ? this.state.standings?.currentGroupCategory : 0;
    const entityChange = nextProps.competitorId !== prevProps.competitorId || JSON.stringify(nextProps.competitionIds) !== JSON.stringify(prevProps.competitionIds);
    const seasonChange = nextProps.seasonNum !== prevProps.seasonNum;

    if (entityChange || seasonChange) {
      this.state.selectedCompetitionId = null;
      this.state.selectedSeasonNum = null;
      this.state.currentStageNum = null;
      this.state.selectedTabIndex = 0;
      this.action();
      this.controller.action(STANDINGS_WIDGET.ACTION_TYPES.changeType, {index: defaultTabIndex, disableFetch: true});
    }
  }
}
